export default theme => ({
    SubNavDesktop: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'block',
            minHeight: 0,
            padding: '8px 15px 8px 0',
            backgroundColor: theme.palette.secondary.main,
            textAlign: 'right',
            '& a': {
                fontFamily: theme.headerFont,
                color: theme.palette.secondary.contrastText,
                textDecoration: 'none',
                textTransform: 'uppercase',
                fontWeight: '600',
                letterSpacing: '0.068em',
                margin: 0,
                fontSize: 14,
                lineHeight: '10px',
                padding: '0 24px',
                borderLeft: '2px solid',
                borderColor: theme.palette.secondary.contrastText,
                display: 'inline-block',
                height: 10,
                transition: 'color .3s ease-in-out',
                '&:hover, &:focus': {
                    color: theme.palette.primary.main,
                },
                '&:nth-of-type(1)': {
                    borderLeft: 'none',
                },
                '&[aria-current="page"]': {
                    textDecoration: 'underline',
                },
            }
        }
    },
})